import React from "react";
import { useTranslation } from "react-i18next";

const legendItemStyle = (bgColor) => ({
  backgroundColor: bgColor || "green",
  borderRadius: "50%",
  height: 10,
  width: 10,
  marginRight: 5,
  display: "inline-block",
});

const legendStyle = {
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  font: "12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif",
  padding: "10px",
  position: "absolute",
  right: "40px",
  top: "73px",
  background: "rgba(255, 255, 255, 0.7)",
  borderRadius: "3px",
};

const CoastalFloodLegend = (props) => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>
          {t("riskAssessment.coastalFlood")} - {props.isTrue} Prot
        </b>
      </div>
      <div>
        <span style={legendItemStyle("#d7191c")}></span>
        10-{t("coverage.year")} {t("riskAssessment.coastalFlood")} {t("riskAssessment.zone")}
      </div>
      <div>
        <span style={legendItemStyle("#fdae61")}></span>
        30-{t("coverage.year")} {t("riskAssessment.coastalFlood")} {t("riskAssessment.zone")}
      </div>
      <div>
        <span style={legendItemStyle("#ffffbf")}></span>
        100-{t("coverage.year")} {t("riskAssessment.coastalFlood")} {t("riskAssessment.zone")}
      </div>
      <div>
        <span style={legendItemStyle("#abdda4")}></span>
        300-{t("coverage.year")} {t("riskAssessment.coastalFlood")} {t("riskAssessment.zone")}
      </div>
      <div>
        <span style={legendItemStyle("#2b83ba")}></span>
        1000-{t("coverage.year")} {t("riskAssessment.coastalFlood")} {t("riskAssessment.zone")}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default CoastalFloodLegend;
